import { render, staticRenderFns } from "./mod5CustomerHistory.vue?vue&type=template&id=d504de10"
import script from "./mod5CustomerHistory.vue?vue&type=script&lang=js"
export * from "./mod5CustomerHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports